import { Model } from '@adobe/aem-spa-page-model-manager'
import { SnackbarProps } from '@ucl/react-library/snackbar'
import { getAEMValue, parseModelJSON } from '@utils/aem'
import DOMPurify from 'dompurify'
import parse from 'html-react-parser'

export const getSnackbarProps = (props: Omit<SnackbarProps, 'message'> & { message: any }): SnackbarProps => {
  const defaultProps: Omit<SnackbarProps, 'message'> = {
    icon: 'checkmarkFilled',
    type: 'primary',
    dismissible: true,
    autoCloseTime: 3000,
    stopAutoCloseOnHover: true,
  }

  return { ...defaultProps, ...props }
}

export const teamName = 'FinSimpleGrow'

export const getAEMTextFromModel = (pageData: Model, fieldName: string, isBoldNeeded: boolean = false): string => {
  const parsedModel = parseModelJSON(pageData)

  if (!parsedModel) {
    console.error('Parsed model data is undefined.')
    return ''
  }
  const aemText = getAEMValue(fieldName, parsedModel, 'text', true, ['<p>', '</p>'])

  if (!aemText) {
    console.error('AEM text not found in AEM model data.')
    return ''
  }
  return isBoldNeeded
    ? aemText.replace(/<span class="semi-bold">(.*?)<\/span>/g, (_match: any, content: any) => {
        return `<b>${content}</b>`
      })
    : aemText
}

type FormatAEMSnackbarTextProps = {
  text: string
  additionalProps?: Record<string, string>
}

export const formatAEMSnackbarText = ({ text, additionalProps }: FormatAEMSnackbarTextProps): React.ReactNode => {
  if (additionalProps) {
    Object.entries(additionalProps).forEach(([key, value]) => {
      const regex = new RegExp(`{\\s*${key}\\s*}`, 'g')
      text = text.replace(regex, value)
    })
  }
  return parse(DOMPurify.sanitize(text))
}
